module.exports = __webpack_public_path__ + "static/media/doctors.9ee3c53d.svg";